<template>
  <BaseModal
    name="sendListPhoneSmsModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="clearData"
    :adaptive="true"
    height="auto"
    @before-open="onOpenModal"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('sendListPhoneSmsModal')"
      ></button>

      <div>
        <div class="tw-app-modal__title">
          Отправить SMS <br />
          выбранным {{ reestrName }}
        </div>
        <div class="tw-mb-[15px]">
          <div class="tw-app-input-type-3-label">
            {{ dataLang["orders_page_btn_text88"] }}
          </div>
          <BaseTextarea
            inputClass="tw-app-input-type-3"
            input-name="text"
            @onInput="updateValue"
            :minHeight="'90'"
            :value="currentText"
          />
        </div>

        <div class="tw-text-forText tw-mt-[15px]">
          <b> {{ dataLang["orders-page__table__header_order_text14"] }}: </b>
          {{ smsStat.countSymbols }}
          {{ dataLang["orders-page__modal_sms"] }}
          {{ smsStat.countSms }} SMS
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            Отправить
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService.js";
export default {
  components: {},

  props: {
    reestrName: { type: String, default: "договорам" },
  },
  data() {
    return {
      updatedValues: {},
      localLoading: false,
      currentText: "",
      numberList: [],
      smsStat: {
        countSymbols: 0,
        countSms: 0,
      },
    };
  },
  methods: {
    clearData() {
      this.updatedValues = {};
      this.numberList = [];
      this.smsStat.countSymbols = 0;
      this.smsStat.countSms = 0;
      this.$emit("close");
    },
    onOpenModal({ params }) {
      this.numberList = params.numberList;
    },
    sendData() {
      if (this.updatedValues.text && this.numberList.length) {
        this.localLoading = true;
        let sendedArray = this.numberList.map((el) => {
          return { phone: el, text: this.updatedValues.text };
        });
        GeneralService.editOrCreate("/sms", sendedArray)
          .then((data) => {
            this.$toast.success(data.data.message);
          })
          .catch((err) => {
            if (e?.response?.data) {
              this.$toast.error(e?.response.data.message, { duration: 5000 });
            }
          })
          .finally(() => {
            this.localLoading = false;
            this.currentText = "";
            this.$modal.hide("sendListPhoneSmsModal");
            this.$emit("close");
          });
      }
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;

      if (data.name == "text") {
        this.updateSmsStat(data.value);
      }
    },
    updateSmsStat(symbols) {
      this.smsStat.countSymbols = symbols.length;
      this.smsStat.countSms = Math.ceil(symbols.length / 70);
    },
  },
  mounted() {},

  created() {},
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>
